import { FvButton } from '@fv/client-components'
import { fvDate } from '@fv/dates'

type Props = {
  date: Date | null
  onDateSelected: (date: Date) => void
}
export const DaySelector = ({ date, onDateSelected }: Props) => {
  const day = date ?? new Date()

  const handleDayChange = (increment: number) => () => {
    onDateSelected(fvDate(day).add(increment, 'day').toDate())
  }
  const handleMonthChange = (increment: number) => () => {
    onDateSelected(fvDate(day).add(increment, 'month').toDate())
  }

  return (
    <div className="sticky -top-4 bg-fv-beer-xlight px-4 py-3 -mx-4 -mt-4 border-b border-fv-beer-medium flex items-center justify-between gap-4 text-sm fa-width-auto z-10">
      <FvButton
        onClick={() => onDateSelected(new Date())}
        icon="calendar-day"
        className="bg-fv-beer-light border border-fv-beer-medium rounded-xs p-2"
      >
        Go to today
      </FvButton>
      <div className="flex items-center">
        <FvButton
          icon="chevron-left"
          onClick={handleDayChange(-1)}
          className="rounded-full w-6 h-6 bg-fv-beer-light border border-fv-beer-medium"
        />
        <div className="w-24 text-center underline decoration-fv-orange-bright underline-offset-4 font-medium">
          {date ? fvDate(date).format('ddd, MMM DD') : 'No day selected'}
        </div>
        <FvButton
          icon="chevron-right"
          onClick={handleDayChange(1)}
          className="rounded-full w-6 h-6 bg-fv-beer-light border border-fv-beer-medium"
        />
      </div>

      <div className="flex items-center">
        <FvButton
          icon="chevron-left"
          onClick={handleMonthChange(-1)}
          className="rounded-full w-6 h-6 bg-fv-beer-light border border-fv-beer-medium"
        />
        <div className="w-20 text-center">{fvDate(day).format('MMM YYYY')}</div>
        <FvButton
          icon="chevron-right"
          onClick={handleMonthChange(1)}
          className="rounded-full w-6 h-6 bg-fv-beer-light border border-fv-beer-medium"
        />
      </div>
    </div>
  )
}
